import React from "react";
import {Link} from "react-router-dom";
import {ThemeLogo} from "../../theme";

const AuthLogo: React.FC = () => {
    return (
        <>
            <div className="text-center mb-5">
                <Link to="/" className="auth-logo">
                    <ThemeLogo variant="dark" />
                </Link>
            </div>
        </>
    );
};

export default AuthLogo;
